<template>
  <div>
    <!-- {{ originObject }} -->
    <div v-if="originObject.attachmentMobileMode == 0">
      <b-button class="btn-photo-take" type="button" @click="openCamera()">
        <span class="icon">
          <i class="tim-icons icon-camera-18"></i>
        </span>
      </b-button>
      <input
        ref="camera"
        class="input-file"
        type="file"
        accept="image/*;capture=camera"
        capture
        @change="captureImage($event)"
      />
    </div>

    <div v-if="originObject.attachmentMobileMode != 0">
      <b-button class="btn-photo-gallery" type="button" @click="addFiles()">
        <span class="icon">
          <i class="tim-icons icon-attach-87"></i>
        </span>
      </b-button>      
      <b-button class="btn-photo-take" type="button" @click="openCamera()">
        <span class="icon">
          <i class="tim-icons icon-camera-18"></i>
        </span>
      </b-button>
      <input
        ref="files"
        class="input-file"
        type="file"
        accept="image/*"
        @change="captureImage($event)"
      />
      <input
        ref="camera"
        class="input-file"
        type="file"
        accept="image/*;capture=camera"
        capture
        @change="captureImage($event)"
      />
    </div>
    <!-- <div v-if="originObject.attachmentMobileMode == 2" class="btn_div">
      <b-button class="btn-photo-take" type="button" @click="addFiles()">
        <span class="icon">
          <i class="tim-icons icon-minimal-down"></i>
        </span>
      </b-button>
      <input
        ref="files"
        class="input-file"
        type="file"
        accept="image/*;capture=camera"
      />
    </div> -->
  </div>
</template>

<script>
export default {
  name: "CameraButtonAppend",
  props: {
    imageSrc: String,
    originObject: Object,
  },
  data: function () {
    return {
      draftImageSrc: "",
    };
  },
  methods: {
    addFiles() {
      this.$refs.files.click();
    },
    openCamera() {
      this.$refs.camera.click();
    },
    captureImage(e) {
      // console.log("Entrou aqui")
      let input = e.target;
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        let _this = this;
        reader.onload = function (e) {
          var img = document.createElement("img");
          img.src = e.target.result;

          img.onload = function () {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = 1080;
            var MAX_HEIGHT = 1080;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            _this.draftImageSrc = canvas.toDataURL("image/jpeg", 0.2);
            if (_this.originObject) {
              _this.$emit(
                "update-image-src",
                _this.originObject,
                _this.draftImageSrc
              );
            } else {
              _this.$emit("update-image-src", _this.draftImageSrc);
            }
          }; // img.onload
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    handleFileUpload(event, object) {
      const fileElement = event.target;
      const file = fileElement.files[0];
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          // convert image file to base64 string
          object.attachments.push({ attachment: reader.result });
          object.attachment = null;
          // this.onDataChange(object);
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
  },
};
</script>

<style scoped>
.btn-photo-take {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  /* border-color: red !important; */
}
.input-file {
  display: none;
}
.btn-photo-gallery {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.right {
  text-align: right;
  width: 100%;
}
.link {
  text-decoration: underline;
  color: white !important;
}
.link2 {
  text-decoration: underline;
}
.attachments {
  display: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>